import { connect } from "react-redux";
import MasterSalaryPenalty from "./Penalty";
import { bindActionCreators } from "redux";
import {masterSalaryPenaltyRequest, salaryByPhone} from "../../../services/redux/Valet/Project/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
const mapStateToProps = (state) => ({
    masterSalaryPenaltyResponse : state.CreateProject.masterSalaryPenaltyResponse,
    salaryByPhoneResponse : state.CreateProject.salaryByPhoneResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        masterSalaryPenaltyRequest,
        documentUploadUrlPublic,
        salaryByPhone
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MasterSalaryPenalty);